<template>
  <footer class="site-footer">
    <div class="container">
      <div class="footer-grid">
        <div class="footer-column">
          <h4>Paradisa Studenté</h4>
          <p>Investasi Nyata di Kawasan Edukasi. Hunian kost premium dengan konsep modern kontemporer yang dirancang untuk kenyamanan dan keuntungan investasi Anda.</p>
        </div>
        <div class="footer-column">
          <h4>Alamat</h4>
          <p>
            <strong>Marketing Office:</strong><br>
            Jl. Dramaga Satu Letutik, RT.02/RW.06, Desa Dramaga, Kec. Dramaga, Kab. Bogor, Jawa Barat
          </p>
          <p>
            <strong>Head Office:</strong><br>
            Sinbad Green Residence, Jl. KH. R. Abdullah Bin Nuh, RT.03/RW.01, Bubulak, Kota Bogor, 16117.
          </p>
        </div>
        <div class="footer-column">
          <h4>Kontak</h4>
          <p>Tertarik untuk diskusi lebih lanjut? Hubungi kami sekarang.</p>
          <a href="https://wa.me/6281234567890?text=Halo, saya tertarik dengan investasi di Paradisa Studenté." target="_blank" class="cta-button">
            Hubungi via WhatsApp
          </a>
        </div>
      </div>
      <div class="footer-bottom">
        <p>&copy; {{ new Date().getFullYear() }} Paradisa Studenté. All rights reserved.</p>
        <p class="developer">Developed by <strong>seruma</strong></p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter'
}
</script>

<style scoped>
.site-footer {
  background-color: #2c3e50; /* Warna biru tua gelap */
  color: #ecf0f1;
  padding: 60px 0 0 0;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.footer-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  margin-bottom: 40px;
}
.footer-column h4 {
  color: #fff;
  font-size: 1.3rem;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;
}
.footer-column h4::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 40px;
  height: 2px;
  background-color: var(--secondary-color);
}
.footer-column p {
  color: #bdc3c7;
  line-height: 1.7;
}
.cta-button {
  background-color: var(--secondary-color);
  color: var(--dark-grey);
  padding: 10px 20px;
  font-size: 15px;
}
.footer-bottom {
  border-top: 1px solid #34495e;
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9rem;
  color: #95a5a6;
}
.developer strong {
  color: #fff;
}
@media (max-width: 992px) {
  .footer-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 768px) {
  .footer-bottom {
    flex-direction: column;
    gap: 10px;
  }
}
</style>